'use client';

import { I18nextProvider } from 'react-i18next';
import { createInstance } from 'i18next';
import { ReactNode, useEffect, useState } from 'react';
import { initReactI18next } from 'react-i18next';

interface TranslationsProviderProps {
  children: ReactNode;
  locale: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resources: any;
}

export default function TranslationsProvider({
  children,
  locale,
  resources
}: TranslationsProviderProps) {
  const [i18n] = useState(() => {
    const i18nInstance = createInstance();
    i18nInstance
      .use(initReactI18next)
      .init({
        lng: locale,
        fallbackLng: 'en',
        resources,
        interpolation: {
          escapeValue: false
        }
      });
    return i18nInstance;
  });

  useEffect(() => {
    i18n.changeLanguage(locale);
  }, [locale, i18n]);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}